import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\InvestorNewsController::index
* @see app/Http/Controllers/Investors/InvestorNewsController.php:13
* @route '//app.finesthub.de/news'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/news',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\InvestorNewsController::index
* @see app/Http/Controllers/Investors/InvestorNewsController.php:13
* @route '//app.finesthub.de/news'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\InvestorNewsController::index
* @see app/Http/Controllers/Investors/InvestorNewsController.php:13
* @route '//app.finesthub.de/news'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\InvestorNewsController::index
* @see app/Http/Controllers/Investors/InvestorNewsController.php:13
* @route '//app.finesthub.de/news'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const InvestorNewsController = { index }

export default InvestorNewsController